import { EChartsCoreOption } from 'echarts';
import {
  ChartDataResponseResult,
  ChartProps,
  DataRecordValue,
  QueryFormColumn,
  QueryFormData,
  SetDataMaskHook,
} from '@superset-ui/core';
import { ColumnConfig } from '@superset-ui/chart-controls';
import {
  DEFAULT_LEGEND_FORM_DATA,
  EchartsLegendFormData,
} from '../../../types';
import { DrillDownLevelData } from '../../types';


export type EchartsMapFormData = QueryFormData &
  EchartsLegendFormData & {
    groupby: QueryFormData[];
    showDbhdsRegion: boolean;
    dbhdsRegion: string;
    metric?: string;
    showLabels: boolean;
    tooltipFormat: string;
    colorRange: string[];
};

export interface EchartsMapChartProps
  extends ChartProps<EchartsMapFormData> {
  formData: EchartsMapFormData;
  queriesData: ChartDataResponseResult[];
  levelInfo: DrillDownLevelData[];
  baseEchartOption: EChartsCoreOption;
}

// @ts-ignore
export const DEFAULT_FORM_DATA: EchartsMapFormData = {
  ...DEFAULT_LEGEND_FORM_DATA,
  groupby: [],
  showLabels: true,
  tooltipFormat: '{a} <br/>{b}: {c}',
  colorRange: ["#008DC4","#95C3E5", "#4EDDE4", "#02B0C2", "#18B5FC"]
};

export interface MapChartTransformedProps {
  formData: EchartsMapFormData;
  height: number;
  width: number;
  echartOptions: EChartsCoreOption;
  setDataMask: SetDataMaskHook;
  labelMap: Record<string, DataRecordValue[]>;
  groupby: QueryFormColumn[];
  enablePopUpDrilldown?: boolean;
  popUpMetrics: object[];
  popUpGroupBy: QueryFormColumn[];
  popUpDropdownColumns: QueryFormColumn[];
  verboseMap?: {[key: string]: string};
  columnConfig: Record<string, ColumnConfig>;
};


export interface MapDataItemOption {
  value?: number;
  name?: string;
  
};

export const tooltipOptions = {
  backgroundColor: '#272833',
  borderRadius: '8',
  borderColor: '#272833',
  textStyle: {
    color: '#E7E7ED',
  },
}
